<template>
  <div
    v-if="itemList"
    class="page has-background-blue with-title"
  >
    <h1 class="page-title has-text-weight-bold has-text-centered is-size-5">
      {{ title }}
    </h1>
    <div class="container pt-5">
      <div class="columns is-multiline is-mobile">
        <VideoListItem
          v-for="item in itemList"
          :key="item.id"
          :data="item"
          @click="openContent(item)"
        />
        <div
          v-if="emptyResult"
          class="column is-12-mobile is-6-tablet is-offset-3-tablet"
        >
          <div class="no-results">
            No se han encontrado resultados.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoListItem from "@/components/lists/VideoListItem";

export default {
  name: 'VideosByGalleryList',
  components: {VideoListItem},
  title: 'Vídeos de galería',
  data: function () {
    return {
      itemList: null,
      title: ""
    }
  },
  computed: {
    emptyResult() {
      if (!this.itemList) {
        return false
      }

      return this.itemList.length === 0
    },
    userToken() {
      return this.$store.state.token
    }
  },
  watch: {
    userToken() {
      this.loadContent()
    }
  },
  beforeMount() {
    this.loadContent()
  },
  methods: {
    async loadContent() {
      try {
        await this.$store.dispatch('initLoading')
        const galleryId = this.$route.params.galleryId
        const gallery = await this.$api.video.getListByGallery(galleryId)
        this.itemList = gallery.videos
        this.title = gallery.title

        this.setPageTitle(`Galería de vídeos - ${gallery.title}`)

        await this.$store.dispatch('finishLoading')
      } catch (error) {
        await this.$store.dispatch('finishLoading')

        await this.handleContentError(error)
      }
    },
    openContent(item) {
      if (item.hasOwnProperty('is_external') && item.is_external === true) {

        window.open(item.external_url, '_blank')
        return
      }
      const id = item.id
      this.$router.push({name: "video-detail", params: {id}})
    }
  }
}
</script>
